import { COMPONENT, register } from '~/core/repository'
import { LanguagePicker } from './ui'

export * as languagePickerModel from './model'

register(LanguagePicker, 'LanguagePicker', COMPONENT)
